import React from 'react';
import {
  useNavigate,
} from 'react-router-dom';
import {
  useDispatch,
} from 'react-redux';
import {
  Formik,
  Field,
} from 'formik';

import {
  coreActions,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  Button,
  SelectField,
} from 'web-components';

import * as S from './styled';
import * as options from './options';

const required = (value?: string) => (value ? undefined : 'Required');

const SitePersonalization = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (payload, actions) => {
    dispatch(
      coreActions.profileSetupRequest({
        payload,
        settings: {
          is_completed_site_personalization: true,
        },
        callbacks: {
          ...actions,
          onSuccess: () => {
            navigate('/welcome');
          },
        },
      }),
    );
  };

  const fields = [
    {
      label: 'What best describes your business? *',
      name: 'business_type',
      validate: required,
      options: options.businessTypeOptions,
    },
    {
      label: 'What best describes you? *',
      name: 'user_type',
      validate: required,
      options: options.userTypeOptions,
    },
    {
      label: 'How many clients/members do you currently have? *',
      name: 'clients_count',
      validate: required,
      options: options.clientCountOptions,
    },
  ];

  return (
    <S.MainContainer>
      <S.Title>
        Tell Us About Yourself
      </S.Title>
      <Formik
        initialValues={{
          business_type: '',
          user_type: '',
          clients_count: '',
        }}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          isSubmitting,
          isValid,
        }) => (
          <S.FormContainer
            as="form"
            onSubmit={handleSubmit}
          >
            {fields.map(field => (
              <S.FieldContainer key={field.name}>
                <Text
                  color="#000"
                  weight={800}
                  size="15px"
                >
                  {field.label}
                </Text>
                <Field
                  name={field.name}
                  options={field.options}
                  validate={field.validate}
                  component={SelectField}
                  isSearchable={false}
                  maxMenuHeight={500}
                  theme={{
                    borderRadius: 5,
                  }}
                  styles={{
                    valueContainer: provided => ({
                      ...provided,
                      fontSize: '15px',
                      lineHeight: '15px',
                      fontWeight: 500,
                    }),
                  }}
                />
              </S.FieldContainer>
            ))}
            <Flex
              width="100%"
              justify="center"
              align="center"
            >
              <Button
                fit
                type="submit"
                spacing="big"
                borderRadius="5px"
                isLoading={isSubmitting}
                isDisabled={!isValid && isSubmitting}
                appearance="primaryBright"
              >
                Next
              </Button>
            </Flex>
          </S.FormContainer>
        )}
      </Formik>
    </S.MainContainer>
  );
};

export default SitePersonalization;
